// extracted by mini-css-extract-plugin
module.exports = {"title":"region_switch_modal_title__4A8GE","message":"region_switch_modal_message__Rtl6j","button":"region_switch_modal_button__aFkSm"};